/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// page
import Page from 'material/structure/page/page';
// group
import Group from 'material/group/group';
// copy
import Copy from 'material/copy/copy';
import Title from 'material/copy/title/title';
import BodyCopy from 'material/copy/bodycopy/bodycopy';
// ctas
import CTAs from 'material/ctas/ctas';
import Button from 'material/ctas/button/button_container';
import SignInCTA from 'material/ctas/signin/signin';
import Link from 'material/ctas/link/link';
// fields
import Form from 'material/form/form_container';
import Field from 'material/form/field/field_container';
// grid
import Grid from 'material/grid/grid';
import GridSet from 'material/grid/gridset/gridset';
import GridItem from 'material/grid/griditem/griditem';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/auth/requestdemo/requestdemo_styles';




/* ========== ~~~~~~~~~~ PAGE : REQUEST DEMO : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class RequestDemoPage extends Component {
    constructor(props) {
        super(props);
        this.formName = 'requestdemo';
    }

    componentDidUpdate = (prevProps) =>{
        if(this.props.fields.pageviews.value !== prevProps.fields.pageviews.value ){
        return this.props.fields.pageviews.value === "lessthan1mil" ? this.showBottomToaster() : null;
        }
    };

    handleRequest = () => {
        if(this.props.fields.pageviews.value !== "lessthan1mil")this.props.requestDemoWithValidation(this.props.fields, this.getFormCallData(), this.handleSucessRequest, this.handleFailedRequest);
    };
    handleSucessRequest = () => {
        const successMessage = 'Your request has been sent successfully';
        this.props.moveToPage('auth/requestsubmitted');
        this.props.discardChanges(this.formName);
        this.props.displaySuccessMessage(successMessage);
    };
    handleFailedRequest = (errorResponse) => {
        const errResponseComment = !!errorResponse.data && !!errorResponse.data.comment ? errorResponse.data.comment : null;
        const errMessage = `Woops, something wrong${!!errResponseComment ? `. ${errResponseComment}` : `Please try again later` }.`;
        this.props.displayErrorMessage(errMessage);
    };
    getFormCallData = () =>{
        const { minMonthlyPageViews,  maxMonthlyPageViews } = this.getPageViews();
        return {
            firstName: this.props.fields.fname.value,
            lastName: this.props.fields.lname.value,
            email: this.props.fields.email.value,
            domain: this.props.fields.domain.value,
            phone: this.props.fields.phone.value,
            phoneCountryCode : "0",
            minMonthlyPageViews,
            maxMonthlyPageViews
        }
    };
    getPageViews() {
        let minMonthlyPageViews = 0;
        let maxMonthlyPageViews = 0;
        switch (this.props.fields.pageviews.value) {
            case 'lessthan1mil':
                maxMonthlyPageViews =  999999;
                break;
            case '1miland10mil':
                minMonthlyPageViews = 1000000;
                maxMonthlyPageViews = 9999999;
                break;
            case '10miland100mil':
                minMonthlyPageViews = 10000000;
                maxMonthlyPageViews = 99999999;
                break;
            case 'morethan100mil':
                minMonthlyPageViews = 100000000;
                break;
            default:
                break;
        }
        return { minMonthlyPageViews, maxMonthlyPageViews }
    };

    handlePageViewsValid = (pageViews) => pageViews.value === "lessthan1mil" ? false : pageViews.valid;

    showBottomToaster = () => this.props.displayMessage({
        type: 'toaster',
        close: true,
        variant: 'attention',
        time: null,
        align: 'bottom-right',
        message: <p className={'pageview'} >"Sorry, we don't currently work with sites with less than 1 Million monthly page views. However, if your main website has larger traffic volume and you wish to test our product on a smaller site first, please click <Link color={'primary'} text={'here'} type={'email'} action={'mailto:contact@insticator.com?Subject=Let\'s%20set%20up%20a%20call!'} /> to contact our Account Management team."</p>,
        handleClick: null
    });

    render() {
        const { lname, fname, email, phone, domain, pageviews } = this.props.fields;
        return(
            <Page name={`requestdemo`} klass={this.props.classes.requestdemo}>
                <Group name={`main`}>
                    <Copy>
                        <Title>
                            <h2>Request Demo</h2>
                        </Title>
                        <BodyCopy>
                            <p>Please fill this form with your details, and let our team create an account for you.</p>
                        </BodyCopy>
                    </Copy>
                    <Form name={`requestdemo`}>
                        <Grid type={`fields`}>
                            <GridSet>
                                <GridItem><Field formName={'requestdemo'} type={`text`} name={`fname`} placeholder={`First Name`} label={`First Name`} info={``} disabled={false} value={fname.value} valid={fname.valid} required /></GridItem>
                                <GridItem><Field formName={'requestdemo'}  type={`text`} name={`lname`} placeholder={`Last Name`} label={`Last Name`} info={``} disabled={false} value={lname.value} valid={lname.valid} required /></GridItem>
                            </GridSet>
                            <GridSet>
                                <GridItem><Field formName={'requestdemo'}  type={`email`} name={`email`} placeholder={`Email`} label={`Email Address`} disabled={false} value={email.value} valid={email.valid} info={``} required /></GridItem>
                                <GridItem><Field formName={'requestdemo'}  type={`tel`} name={`phone`} placeholder={`Phone`} label={`Phone Number`} info={``} disabled={false} value={phone.value} valid={phone.valid} required /></GridItem>
                            </GridSet>
                            <GridSet>
                                <GridItem><Field formName={'requestdemo'}  type={`url`} name={`domain`} placeholder={`example.com`} label={`Domain`} info={``} disabled={false} value={domain.value} valid={domain.valid} required /></GridItem>
                                <GridItem>
                                    <Field formName={'requestdemo'} type={`select`} name={`pageviews`} placeholder={``} label={<span>Est. Monthly Pageviews</span>} info={``} disabled={false} value={pageviews.value} valid={this.handlePageViewsValid(pageviews)}  required options={[
                                        { name:'lessthan1mil', value:'lessthan1mil', text:'Less than 1 Million' },
                                        { name:'1miland10mil', value:'1miland10mil', text:'Between 1 Million and 10 Million' },
                                        { name:'10miland100mil', value:'10miland100mil', text:'Between 10 Million and 100 Million' },
                                        { name:'morethan100mil', value:'morethan100mil', text:'More than 100 Million' },
                                    ]} />
                                </GridItem>
                            </GridSet>
                        </Grid>
                        <CTAs>
                            <Button type={'action'} action={this.handleRequest} variant={`primary`} name={`requestdemo`} text={`Request demo`} />
                        </CTAs>
                    </Form>
                </Group>
                <Group name={`callout`}>
                    <SignInCTA copy={'Already have an account?'} />
                </Group>
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(RequestDemoPage);
